import { render, staticRenderFns } from "./openAccPersonalInfo.vue?vue&type=template&id=4cc7064b&scoped=true"
import script from "./openAccPersonalInfo.vue?vue&type=script&lang=js"
export * from "./openAccPersonalInfo.vue?vue&type=script&lang=js"
import style0 from "./openAccPersonalInfo.vue?vue&type=style&index=0&id=4cc7064b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc7064b",
  null
  
)

export default component.exports